exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dpsobl-component{border:0;font-size:.75em}.capAlign{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/DpsObl.css
// module id = 139
// module chunks = 0